export function generateSecureRandomNumber() {
    return crypto.getRandomValues(new Uint32Array(1))[0] / 0x100000000;
}
